<template>
  <basic-container>
    <!-- :search.sync="query"  -->
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      :before-close="handleClose"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menu" slot-scope="scope">
        <el-button
          type="text"
          size="small"
          icon="el-icon-s-tools"
          v-if="permissionList.addcarBtn"
          @click="openAddCarDialog(scope.row)"
          >添加车辆
        </el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-s-tools"
          v-if="permissionList.viewcarBtn"
          @click="openViewCarDialog(scope.row)"
          >查看车辆
        </el-button>
      </template>
      <template slot-scope="scope" slot="carParkNumber">
        <wq-overHidden :content="scope.row.carParkNumber">
          <span>{{ scope.row.carParkNumber }}</span>
        </wq-overHidden>
      </template>

      <template slot-scope="scope" slot="regionIdSearch">
        <el-select
          clearable
          v-model="query.regionId"
          placeholder="区域名称"
          filterable
          style="width: 100%"
        >
          <el-option
            v-for="(item, index) in regionList"
            :key="index"
            :label="item.spaceName"
            :value="item.id"
          ></el-option>
        </el-select>
      </template>

      <template slot-scope="scope" slot="parkingLotIdSearch">
        <el-select
          @change="spaceIdChange"
          v-model="query.parkingLotId"
          placeholder="车场名称"
          style="width: 100%"
        >
          <el-option
            v-for="(item, index) in carParkList"
            :key="index"
            :label="item.title"
            :value="item.id"
          ></el-option>
        </el-select>
      </template>

      <template slot-scope="scope" slot="regionIdForm">
        <el-select
          :disabled="regionFlag"
          clearable
          v-model="form.regionId"
          placeholder="请选择 区域名称"
          filterable
          style="width: 100%"
        >
          <el-option
            v-for="(item, index) in regionList"
            :key="index"
            :label="item.spaceName"
            :value="item.id"
          ></el-option>
        </el-select>
      </template>
      <template slot-scope="scope" slot="parkingLotIdForm">
        <el-select
          clearable
          @change="spaceIdChange_"
          disabled
          v-model="form.parkingLotId"
          placeholder="请选择 车场名称"
          filterable
          style="width: 100%"
        >
          <el-option
            v-for="(item, index) in carParkList"
            :key="index"
            :label="item.title"
            :value="item.id"
          ></el-option>
        </el-select>
      </template>
      <template slot="carParkGroupName" slot-scope="scope">
        <wq-overHidden :content="scope.row.carParkGroupName">
          <span>{{ scope.row.carParkGroupName }}</span>
        </wq-overHidden>
      </template>
    </avue-crud>
    <addCar ref="addCar"></addCar>
    <viewCars ref="viewCars"></viewCars>
  </basic-container>
</template>

<script>
import dayjs from 'dayjs';
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  sync,
  updateStatus,
  getRegionList,
} from '@/api/v4ward/carv2/cargroup';
import { getSpaceTree as getCarParkList } from '@/api/v4ward/car/carparkspacev2';
import { mapGetters } from 'vuex';
import addCar from './addCar.vue';
import viewCars from './viewCars.vue';
export default {
  components: { addCar, viewCars },
  data: function () {
    return {
      regionFlag: false,
      parkingLotFlag: false,
      form: {},
      query: {},
      search: {},
      regionList: [],
      parkingLotList: [],
      loading: true,
      reWrite: false,
      firstDisplayFlag: false,
      tempCarParkId: '',
      carParkList: [],
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 50,
        tip: true,
        border: true,
        index: true,
        viewBtn: false,
        selection: true,
        columnBtn: true,
        refreshBtn: true,
        delBtn: true,
        searchMenuSpan: 24,
        labelWidth: 100,
        dialogClickModal: false,
        searchLabelWidth: 100,
        stripe: true,
        column: [
          {
            label: '车场名称',
            prop: 'spaceName',
            // hide: true,
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            search: false,
          },
          {
            label: '车场名称',
            prop: 'parkingLotId',
            type: 'tree',
            disabled: true,
            formslot: true,
            searchClearable: false,
            hide: true,
            showColumn: false,
            // editDisplay: false,
            // addDisplay: false,
            // viewDisplay: false,
            search: true,
            searchslot: true,
            searchSpan: 6,
            // dicUrl: '/api/v4ward/carv2/ParkSpace/getCarParkList',
            props: { label: 'title', value: 'id' },
            rules: [
              {
                required: true,
                message: '请选择车场名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '区域名称',
            prop: 'regionId',
            type: 'tree',
            searchClearable: false,
            formslot: true,
            // editDisplay: false,
            // addDisplay: false,
            // viewDisplay: false,
            search: true,
            searchslot: true,
            searchSpan: 6,
            hide: true,
            showColumn: false,

            rules: [
              {
                required: true,
                message: '请选择车场名称',
                trigger: 'change',
              },
            ],
          },

          {
            label: '区域名称',
            prop: 'regionName',
            type: 'tree',
            searchClearable: false,
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            // search: true,
            searchSpan: 6,
            // dicUrl: '/api/v4ward/carv2/ParkSpace/getRegionList?spaceId='+this.parkingLotId,
            props: { label: 'spaceName', value: 'id' },
            rules: [
              {
                required: true,
                message: '请选择车场名称',
                trigger: 'blur',
              },
            ],
          },

          {
            label: '车位组名称',
            prop: 'carParkGroupName',
            slot: true,
            span: 12,
            maxlength: 20,
            search: true,
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: '请输入车位组名称',
                trigger: 'blur',
              },
            ],
          },
          {
            label: "车牌号",
            prop: "plateNumbers",
            slot:true,
            display: false,
            span: 12,
            maxlength:20,
            search:true,
            hide: true,
            showWordLimit:true,
          },
          {
            label: '车位数',
            prop: 'carParkNumber',
            span: 12,
            type: 'input',
            maxlength: 8,
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: '请输入车位数',
                trigger: 'blur',
              },
              {
                type: 'string',
                required: true,
                pattern: /^[0-9]+$/,
                trigger: 'change',
                message: '车位数格式错误',
              },
            ],
          },
          {
            label: '责任人',
            prop: 'responsiblePersonName',
            search: true,
            display: true,
            type: 'input',
            maxlength: 20,
            showWordLimit: true,
            span: 12,
            rules: [
              {
                required: true,
                message: '请输入责任人',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '责任人电话',
            prop: 'responsiblePersonPhone',
            // search: true,
            display: true,
            span: 12,
            rules: [
              {
                required: true,
                message: '请输入责任人电话',
                trigger: 'blur',
              },
              {
                type: 'string',
                required: true,
                pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
                message: '责任人电话格式错误',
              },
            ],
          },
          {
            label: '开始时间',
            prop: 'carParkStartTime',
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            span: 12,
            search: false,
          },
          {
            label: '结束时间',
            prop: 'carParkEndTime',
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            span: 12,
            search: false,
          },
          {
            label: '截至时间',
            prop: 'endTimeRange',
            searchSpan: 6,
            type: 'datetimerange',
            defaultTime: ['00:00:00', '23:59:59'],
            showColumn: false,
            startPlaceholder: '开始时间',
            endPlaceholder: '结束时间',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            searchRange: true,
            hide: true,
            rules: [
              {
                required: true,
                message: '请输入截至时间',
                trigger: 'blur',
              },
            ],
          },
        ],
      },
      dialogFlage: false,
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.cargrouprule_add, false),
        addcarBtn: this.vaildData(this.permission.cargrouprule_add_groupcars, false),
        viewcarBtn: this.vaildData(this.permission.cargrouprule_view_groupcars, false),
        delBtn: this.vaildData(this.permission.cargrouprule_delete, false),
        editBtn: this.vaildData(this.permission.cargrouprule_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  watch: {
    'form.matchType'() {
      if (this.form.matchType === 1) {
        this.findObject(this.option.column, 'numberFrom').display = true;
        this.findObject(this.option.column, 'numberTo').display = true;

        this.findObject(this.option.column, 'numberFromOne').display = false;
        this.findObject(this.option.column, 'numberToOne').display = false;
      }
      if (this.form.matchType === 2) {
        this.findObject(this.option.column, 'numberFrom').display = false;
        this.findObject(this.option.column, 'numberTo').display = false;

        this.findObject(this.option.column, 'numberFromOne').display = true;
        this.findObject(this.option.column, 'numberToOne').display = true;
      }
    },
  },
  created() {
    this.initSearchData();
    this.option.height = this.bodyHeight - 450;
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        document
          .querySelector(
            '#avue-view  div.avue-crud > div.avue-crud__menu > div.avue-crud__right > button:nth-child(3)'
          )
          .addEventListener('click', () => {
            if (this.option.height == this.bodyHeight - 450) {
              this.option.height = this.bodyHeight - 330;
            } else {
              this.option.height = this.bodyHeight - 450;
            }
            this.$refs.crud.getTableHeight();
          });
      }, 1000);
    });
  },
  methods: {
    // 打开添加车辆弹窗
    openAddCarDialog(row) {
      this.$refs.addCar.openDialog(row);
    },
    openViewCarDialog(row) {
      this.$refs.viewCars.openDialog(row);
    },
    // 弹窗关闭前
    handleClose(done) {
      if (this.dialogFlage) {
        done();
        return;
      }
      this.$confirm('确认关闭?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          done();
        })
        .catch(() => {});
    },
    spaceIdChange_(val) {
      this.form = Object.assign({}, this.form, {
        parkingLotId: val,
      });
      let self = this;
      this.form = Object.assign({}, this.form, {
        regionId: '',
      });

      self.regionList = [];
      getRegionList({ spaceId: val }).then((res) => {
        self.regionList = res.data;
        if (res.data.length > 0) {
          this.form = Object.assign({}, this.form, {
            regionId: res.data[0].id,
          });
        }
        this.$forceUpdate();
      });
    },
    spaceIdChange(val) {
      console.log('spaceIdChange===========>', val);
      this.query = Object.assign({}, this.query, {
        parkingLotId: val,
      });
      let self = this;
      this.query = Object.assign({}, this.query, {
        regionId: '',
      });
      console.log(this.query);
      getRegionList({ spaceId: val }).then((res) => {
        self.regionList = res.data;
        if (res.data.length > 0) {
          this.query = Object.assign({}, this.query, {
            regionId: '',
          });
        }
      });
    },
    async initSearchData() {
      await getCarParkList().then((res) => {
        this.carParkList = res.data;
        this.tempCarParkId = res.data[0] ? res.data[0].id : '';
        this.query.parkingLotId = res.data[0] ? res.data[0].id : '';
        // this.tempCarParkId= '1547470012100710402';
        // this.query.parkingLotId = '1547470012100710402';
      });
      await getRegionList({ spaceId: this.tempCarParkId }).then((res) => {
        this.regionList = res.data;
      });
      this.onLoad();
    },
    getCarParkNameById(carParkId) {
      console.log();
      let carParkName = '';
      this.carParkList.forEach(function (value, index, array) {
        if (value.id === carParkId) {
          carParkName = value.spaceName;
          // return;
        }
      });
      return carParkName;
    },
    stopButton(row) {
      updateStatus({ id: row.id, status: 0 }).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          console.log(error);
        }
      );
    },
    startButton(row) {
      updateStatus({ id: row.id, status: 1 }).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          console.log(error);
        }
      );
    },
    hideStartButton(row) {
      return row.status === 1;
    },
    hideStopButton(row) {
      return row.status === 0;
    },
    rowSave(row, loading, done) {
      console.log('rowSave====================>', row);
      row.carParkStartTime = row.endTimeRange[0];
      row.carParkEndTime = row.endTimeRange[1];
      // if (row.matchType === 2) {
      //   row.numberFrom = row.numberFromOne;
      //   row.numberTo = row.numberToOne;
      // }
      // if(row.numberFrom===row.numberTo){
      //   this.$message.error('车牌字母与匹配字母重复!');
      //   done();
      //   return;
      // }
      // row.parkingLotIds = row.parkingLotIds.join(",");
      add(row).then(
        () => {
          this.dialogFlage = true;
          loading();
          this.onLoad();

          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      row.carParkStartTime = row.endTimeRange[0];
      row.carParkEndTime = row.endTimeRange[1];
      update(row).then(
        () => {
          this.dialogFlage = true;
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    syncButton() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据同步?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return sync({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      let self = this;

      this.regionFlag = false;
      this.parkingLotFlag = false;
      if (['edit', 'view'].includes(type)) {
        this.parkingLotFlag = true;
        if (['view'].includes(type)) {
          this.regionFlag = true;
          this.dialogFlage = true;
        } else {
          this.dialogFlage = false;
        }
        getDetail({ id: this.form.id }).then(({ data }) => {
          // this.form = data;
          // console.log('<================beforeOpen================>');
          // this.form.parkingLotIds = data.parkingLotId;
          // if (data.matchType === 2) {
          //   this.form.numberFromOne = data.numberFrom;
          //   this.form.numberToOne = data.numberTo;
          // }
          // let startArr = self.form.carParkStartTime.split('T');
          // let endArr = self.form.carParkEndTime.split('T');
          // this.form.endTimeRange = [startArr[0]+' '+startArr[1]+':00',endArr[0]+' '+endArr[1]+':00']
          // this.form.endTimeRange = [startArr[0]+' '+startArr[1],endArr[0]+' '+endArr[1]]
          this.form = data;
          let startArr = self.form.carParkStartTime;
          let endArr = self.form.carParkEndTime;
          // this.form.endTimeRange = [startArr[0]+' '+startArr[1]+':00',endArr[0]+' '+endArr[1]+':00'];

          this.form.endTimeRange = [startArr, endArr];
        });
      } else {
        let self = this;
        this.form.parkingLotId = this.query.parkingLotId;
        this.form = Object.assign({}, self.form, {
          parkingLotId: self.query.parkingLotId,
        });
        console.log('beforeOpen==============>', type);
      }
      done();
    },
    searchReset() {
      this.query = {
        parkingLotId: this.tempCarParkId,
      };

      this.onLoad({
        pageSize: 10,
        currentPage: 1,
        total: 0,
      });
    },
    searchChange(params, done) {
      console.log('params==============>', params);
      // this.query = params;
      let self = this;
      self.query = {
        parkingLotId: self.query.parkingLotId,
        regionId: self.query.regionId,
      };
      this.query = Object.assign({}, this.query, params);
      this.page.currentPage = 1;
      console.log('this.query========>', this.query);
      if (params.endTimeRange && params.endTimeRange.length > 0) {
        this.query.startTime = this.query.endTimeRange[0];
        this.query.endTime = this.query.endTimeRange[1];
      }

      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      let self = this;
      page = page || this.page;
      // /如果加载列表时propertyParentId为空，则将propertyParentId置为当前的第一个房产小区
      if (!this.query.parkingLotId) {
        return;
      }
      this.tempCarParkId = this.query.parkingLotId;
      this.loading = true;

      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
          if (this.firstDisplayFlag) {
            let ent = document.querySelector('input[placeholder="车场名称"]');
            ent.value = this.getCarParkNameById(self.query.parkingLotId);
            this.tempCarParkId = this.query.parkingLotId;
            //关闭默然显示，重刷页面时才开启默认显示
            this.firstDisplayFlag = false;
          }
        }
      );
    },
  },
};
</script>

<style>
.tooltipContent {
  width: 70px;

  height: 57px;

  overflow: hidden;

  text-overflow: ellipsis;

  display: -webkit-box;

  -webkit-line-clamp: 2;

  -webkit-box-orient: vertical;
}
</style>

<style scoped>
.el-input.is-disabled .el-input__inner {
  color: red !important;
}
::v-deep .avue-form__menu--center {
  text-align: right;
  /* width: 100% !important; */
}
::v-deep .avue-crud__search .el-form-item--small.el-form-item {
  width: 100%;
}
</style>
